import { defineStore } from "pinia";
import { ref } from "vue";

export const useGlobalStore = defineStore("global", () => {
    const isDevelop = ref(false); //是否桌面端
    const isCn = ref(false); //是否国内，以.cn结尾
    const mobile = ref("+603 62512322"); //联系电话  国内400-108-7969 马来西亚+603 62512322
    const license = ref(""); //备案号

    const updateIsDevelop = () => {
        const screenWidth = window.innerWidth;
        isDevelop.value = screenWidth > 768;
    };

    const checkIsCn = () => {
        const hostName = window.location.hostname;
        isCn.value = hostName.endsWith('.cn');
        if (hostName.endsWith('.cn')) {
            mobile.value = "400-966-5278"
        }
        if (hostName == "www.castrol-autofilm.com.cn") {
            license.value = "沪ICP备2020031684号-14";
        } else if (hostName == "www.castrolautofilm.com.cn") {
            license.value = "沪ICP备17031962号-2";
        }
    };

    return {
        isDevelop,
        updateIsDevelop,
        isCn,
        checkIsCn,
        mobile,
        license
    };
});